import { authHeaders } from "../../utils/authActions";
import axios from "axios";

const formatDate = () => {
  try {
    const date = new Date();
    const pad = (n) => (n < 10 ? "0" + n : n);

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const year = date.getFullYear();
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  } catch (_) {
    return "unretrieved";
  }
};

async function sendErrorMessage(baseUrl, token, data) {
  return axios.post(
    `${baseUrl}/api/v1/users/contact_admin/`,
    data,
    authHeaders(token)
  );
}

export function handleErrorReport(receivedError, requestID) {
  try {
    let baseUrl = "";
    if (window.sessionStorage.getItem("url") !== null) {
      baseUrl = JSON.parse(window.sessionStorage.getItem("url"));
    } else if (window.location.hostname === "app.speqqle.com") {
      baseUrl = "https://beprod1.speqqle.com"; 
    } else if (window.location.hostname === "test.speqqle.com") {
      baseUrl = "https://betest.speqqle.com";
    } else {
      baseUrl = "https://belab.speqqle.com";
    }

    const authTokenSession = JSON.parse(
      window.sessionStorage.getItem("authToken")
    );

    const currentUserSession = window.sessionStorage.getItem("currentUser");

    let currentUserID = "unretrieved";

    if (currentUserSession !== null) {
      try {
        const parsedUser = JSON.parse(currentUserSession);

        if (Object.prototype.hasOwnProperty.call(parsedUser, "id")) {
          currentUserID = parsedUser.id;
        }
      } catch (_) {
        console.log("Current user parsing error.");
      }
    }

    if (authTokenSession !== null) {
      const currentUrl = window.location.href;
      const constructedEmail = `<h3>BE ERROR REPORT FROM:</h3>
      <p><strong>USER ID:</strong> ${currentUserID}</p>
      <p><strong>TIME:</strong> ${formatDate()}</p>
      <p><strong>ORIGIN:</strong> ${currentUrl}</p>
      <p><strong>ERROR RECEIVED FROM THE BE:</strong></p>
      <pre>${receivedError}</pre>
      <p><strong>REQUEST ID:</strong> ${requestID}</p>`;

      const messagePayload = {
        email_title: "MANUAL BE ERROR REPORT",
        email_content: constructedEmail,
      };

      sendErrorMessage(baseUrl, authTokenSession, messagePayload)
        .then(() => {
          return true;
        })
        .catch((e) => {
          console.log("error: ", e);
          return false;
        });
    } else {
      return false;
    }
  } catch (_) {
    return false;
  }
}

export function handleFeInterfaceErrorReport(receivedErrorList) {
  try {
    let baseUrl = "";
    if (window.sessionStorage.getItem("url") !== null) {
      baseUrl = JSON.parse(window.sessionStorage.getItem("url"));
    } else if (window.location.hostname === "app.speqqle.com") {
      baseUrl = "https://beprod1.speqqle.com";
    } else if (window.location.hostname === "test.speqqle.com") {
      baseUrl = "https://betest.speqqle.com";
    } else {
      baseUrl = "https://belab.speqqle.com";
    }

    const authTokenSession = JSON.parse(
      window.sessionStorage.getItem("authToken")
    );

    const currentUserSession = window.sessionStorage.getItem("currentUser");

    let currentUserID = "unretrieved";

    if (currentUserSession !== null) {
      try {
        const parsedUser = JSON.parse(currentUserSession);

        if (Object.prototype.hasOwnProperty.call(parsedUser, "id")) {
          currentUserID = parsedUser.id;
        }
      } catch (_) {
        console.log("Current user parsing error.");
      }
    }

    if (authTokenSession !== null) {
      const currentUrl = window.location.href;
      const constructedEmail = `<h3>FE INTERFACE ERROR REPORT FROM:</h3>
      <p><strong>USER ID:</strong> ${currentUserID}</p>
      <p><strong>TIME:</strong> ${formatDate()}</p>
      <p><strong>ORIGIN:</strong> ${currentUrl}</p>
      <p><strong>ERROR FROM THE FE:</strong></p>
      <pre>${JSON.stringify(receivedErrorList, null, 2)}</pre>`;

      const messagePayload = {
        email_title: "AUTOMATIC FE INTERFACE ERROR REPORT",
        email_content: constructedEmail,
      };

      sendErrorMessage(baseUrl, authTokenSession, messagePayload)
        .then(() => {
          return true;
        })
        .catch((e) => {
          console.log("error: ", e);
          return false;
        });
    } else {
      return false;
    }
  } catch (_) {
    return false;
  }
}
